import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-6 flex items-center" }




export default /*@__PURE__*/_defineComponent({
  __name: 'CustomSlider',
  props: {
  modelValue: { type: Number, required: true },
  min: { type: Number, default: 0.1 },
  max: { type: Number, default: 3 },
  step: { type: Number, default: 0.01 },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function updateSliderValue(clientX: number, rect: DOMRect) {
  const percent = (clientX - rect.left) / rect.width;
  const rawValue = props.min + percent * (props.max - props.min);
  const stepped = Math.round(rawValue / props.step) * props.step;
  emit("update:modelValue", Math.min(props.max, Math.max(props.min, stepped)));
}

function enableListeners(rect: DOMRect) {
  const move = (ev: MouseEvent) => updateSliderValue(ev.clientX, rect);
  const up = () => {
    window.removeEventListener("mousemove", move);
    window.removeEventListener("mouseup", up);
  };

  window.addEventListener("mousemove", move);
  window.addEventListener("mouseup", up);
}

function onClickTrack(e: MouseEvent) {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
  updateSliderValue(e.clientX, rect);
  enableListeners(rect);
}

function onThumbDown(e: MouseEvent) {
  const track = (e.currentTarget as HTMLElement).parentElement as HTMLElement;
  const rect = track.getBoundingClientRect();
  enableListeners(rect);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "relative w-full h-2 bg-hover border border-muted rounded cursor-pointer",
      onMousedown: onClickTrack
    }, [
      _createElementVNode("div", {
        class: "absolute top-0 left-0 h-2 bg-muted rounded-l",
        style: _normalizeStyle({ width: ((__props.modelValue - __props.min) / (__props.max - __props.min)) * 100 + '%' })
      }, null, 4),
      _createElementVNode("div", {
        class: "absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-brown cursor-pointer",
        style: _normalizeStyle({ left: ((__props.modelValue - __props.min) / (__props.max - __props.min)) * 100 + '%' }),
        onMousedown: onThumbDown
      }, null, 36)
    ], 32)
  ]))
}
}

})